import React, { useRef } from 'react';
import { Modal } from 'antd';
import AddMemberToTeamForm from '../AddMemberToTeamForm';
import { ButtonsContainer, Cancel, Container, Create, SubTitle, Title } from './styles';
const AddTeamMembersToProjectModal = ({
  teamId,
  title,
  subtitle,
  project,
  isVisible,
  isUpdating,
  onOk,
  onCancel
}) => {
  const formRef = useRef();
  return <Modal visible={isVisible} footer={null} data-testid="add-team-members-to-project-modal">
      <Title>{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
      <Container>
        <AddMemberToTeamForm project={project} teamId={teamId} ref={formRef} onOk={onOk} Buttons={<ButtonsContainer>
              <Cancel onClick={() => {
          formRef.current?.clearForm();
          onCancel();
        }} disabled={isUpdating} data-testid="add-team-members-to-project-modal-cancel">
                CANCEL
              </Cancel>
              <Create htmlType="submit" loading={isUpdating}>
                CONFIRM
              </Create>
            </ButtonsContainer>} />
      </Container>
    </Modal>;
};
export default AddTeamMembersToProjectModal;